
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'badge cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n      ', badge, '\n    ');
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('a', {
                    'href': this.url,
                    'className': 'card card-product text-start'
                }, _createElement.apply(this, [
                    'span',
                    { 'className': 'badges' },
                    !this.out_of_stock && this.compare_at_price > this.price ? _createElement('span', {
                        'className': 'badge badge-sale',
                        'key': '87'
                    }, 'On sale') : null,
                    !this.out_of_stock && !this.is_backorder ? _createElement('span', {
                        'className': 'badge badge-in-stock',
                        'key': '208'
                    }, 'In stock') : null,
                    this.out_of_stock && !this.is_backorder ? _createElement('span', {
                        'className': 'badge badge-sold-out',
                        'key': '320'
                    }, 'Sold out') : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ]), _createElement('div', { 'className': 'product--media product-images-wrapper mb-2' }, _createElement('div', {
                    'className': 'product--media square',
                    'data-mediaid': this.id
                }, _createElement('a', { 'className': 'd-block product-link position-relative w-100' }, _createElement('img', {
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'src': this.resizeImage(this.image2),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '937'
                }) : null))), _createElement('div', { 'className': 'text-block text-md-start text-start fs-xs mb-md-0 mb-0' }, _createElement('p', { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })), _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'm-0 product_title text-black fs-base left text-start fw-bold text-math-auto'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('p', {
                    'className': 'product__sku ls-4 m-0 text-left',
                    'id': 'Sku-' + this.id,
                    'role': 'status'
                }, _createElement('span', { 'className': 'visually-hidden' }, 'SKU:'), _createElement('span', { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } })), _createElement('div', { 'className': 'price-block mb-2 mt-lg-4 mt-2 text-left' }, _createElement('div', { 'className': 'align-items-center flex-wrap d-flex' }, _createElement('div', { 'className': 'align-items-center d-flex flex-wrap column-gap-2 me-2' }, _createElement('span', { 'className': 'price m-0 p-0 money' }, ' ', this.formatPrice(this.price), ' '), this.compare_at_price && this.compare_at_price > this.price ? _createElement('del', {
                    'className': 'price small m-0 p-0 money d-inline-block',
                    'key': '2118'
                }, '\n          ', this.formatPrice(this.compare_at_price), '\n        ') : null), this.compare_at_price && this.compare_at_price > this.price ? _createElement('span', {
                    'className': 'badge badge-discount',
                    'key': '2338'
                }, '\n        ', this.calcDiscount(this.price, this.compare_at_price), '% off\n      ') : null), _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'id': 'product-form-installment',
                    'acceptCharset': 'UTF-8',
                    'className': 'installment caption-large',
                    'encType': 'multipart/form-data',
                    'data-productid': this.id
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'form_type',
                    'value': 'product'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'utf8',
                    'value': '\u2713'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'data-productid': this.id,
                    'value': this.variant_ids
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'product-id',
                    'value': this.id
                }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                    'type': 'hidden',
                    'name': 'properties[Fitment]',
                    'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                    'key': '3018'
                }) : null)), this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '3242'
                }) : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'row cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []